const SITE_LLD_SELECTED = 'site_lld_selected';
const SITE_LLD_PENDING = 'site_lld_pending';
const SITE_LLD_DOWNLOADED = 'site_lld_downloaded';
const SITE_LLD_FAILED = 'site_lld_failed';

export {
  SITE_LLD_SELECTED,
  SITE_LLD_PENDING,
  SITE_LLD_DOWNLOADED,
  SITE_LLD_FAILED,
};



// WEBPACK FOOTER //
// ./src/store/sitesLld/types.js